enum ExpensesTypes {
  Item = "Item",
  Time = "Time",
  Travel = "Travel",
  TravelOT = "TravelOT",
  LaborOT = "LaborOT",
  Labor = "Labor",
  MiscItem = "MiscItem",
  Mileage = "Mileage",
}

export default ExpensesTypes;
